const topics = [
  { label: '最新院线', hot: true, count: '326部' },
  { label: '热播剧集', hot: true, count: '1.2万集' },
  { label: '高分电影', hot: false, count: '890部' },
  { label: '国产剧', hot: true, count: '2.3万集' },
  { label: '韩剧精选', hot: false, count: '560部' },
  { label: '美剧专区', hot: false, count: '780部' },
  { label: '热门综艺', hot: true, count: '420档' },
  { label: '人气动漫', hot: true, count: '1.5万集' },
  { label: '动作大片', hot: false, count: '650部' },
  { label: '悬疑推理', hot: false, count: '380部' },
  { label: '喜剧合集', hot: false, count: '520部' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2 text-center">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">发现当下最受欢迎的影视类型与热度标签</p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t, i) => (
            <a
              key={i}
              href="#topics"
              className="group inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-background-300/60 bg-background-50 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                {t.label}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{t.count}</span>
              {t.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse flex-shrink-0"></span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}